import { z } from 'zod';

export const sourceSchema = z.object({
  id: z.string().uuid(),
  feed_id: z.string().uuid(),
  url: z.string().url(),
  created_at: z.string().datetime(),
});

export type Source = z.infer<typeof sourceSchema>;

export const createSourceSchema = z.object({
  feed_id: z.string().uuid(),
  url: z.string().url(),
});

export type CreateSource = z.infer<typeof createSourceSchema>;
